import { render, staticRenderFns } from "./editData.vue?vue&type=template&id=05d056ff&scoped=true"
import script from "./editData.vue?vue&type=script&lang=js"
export * from "./editData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d056ff",
  null
  
)

export default component.exports